import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../store';
import { ReviewsState } from './model';
import { REVIEWS_LOADERS } from './utils';

export const selectReviewsState = (state: RootState) => state.reviews;

export const selectCleanerReviews = createSelector(
  selectReviewsState,
  (state: ReviewsState) => state.cleanerReviews,
);

export const makeSelectReviewsLoader = (key: REVIEWS_LOADERS) =>
  createSelector(selectReviewsState, ({ loaders }) => loaders[key] ?? false);

export const selectMetrics = createSelector(
  selectReviewsState,
  (state: ReviewsState) => state.reviewMetrics,
);

export const selectMetricsById = createSelector(selectMetrics, (metrics) =>
  metrics.reduce((acc, metric) => ({ ...acc, [metric._id]: metric }), {}),
);

export const selectHasPendingReviews = createSelector(
  selectReviewsState,
  ({ hasPendingReviews }) => hasPendingReviews,
);
